const envConfig = {
    mock: true,
    productionSourceMap: false,
    assetsPublicPath: "./",
    publicPath: "../",
    baseURL: "http://sunwin.zhengjianfeng.cn/sms",
    logoutURL:"http://sunwin.zhengjianfeng.cn",
    portalURL:"http://sunwin.zhengjianfeng.cn",
    enableLogin: true
}
exports.config = envConfig;
